import Login from '@domains/auth/views/Login.vue'
import Recover from '@domains/auth/views/password/Recover.vue'
import ResetPassword from '@domains/auth/views/password/ResetPassword.vue'

export default [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: { requiresAuth: false }
  },
  {
    path: '/login/recover',
    component: Recover,
    name: 'Recover',
    meta: { requiresAuth: false }
  },
  {
    path: '/login/reset-password',
    component: ResetPassword,
    name: 'ResetPassword',
    props: (route) => ({
      user: route.query.user,
      code: route.query.code
    }),
    meta: { requiresAuth: false }
  }
]
